import React, { Component } from 'react';
import NavigationLink from 'components/Layout/Navigation/NavigationLink';

import { I18n } from 'react-i18next';
import i18n from '../../i18n';

export default class BlogItem extends Component {
  render() {
    return [
      <I18n>
        {(t, { i18n }) => (
          <NavigationLink
            className={this.props.className}
            to={`/blog/${this.props.data.slug}`}
          >
            <div>
              <div className='blogGrid-blogItem-mediaContainer'>
                <div
                  className='blogGrid-blogItem-media'
                  style={{
                    backgroundImage: `url(${this.props.data.thumbnail})`,
                  }}
                />
              </div>
              <span>
                {this.props.data.author} - {this.props.data.date}
              </span>
              <h2 dangerouslySetInnerHTML={{ __html: this.props.data.title }} />
            </div>
          </NavigationLink>
        )}
      </I18n>,
    ];
  }
}



// WEBPACK FOOTER //
// ./src/components/BlogGrid/BlogItem.jsx